import React from 'react';

// Crea il contesto con un valore di default null (o un oggetto vuoto)
export const UserContext = React.createContext(null);
